/* eslint-disable camelcase */
export default class User {
  initials = '';
  constructor (data) {
    Object.assign(this, data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/User.js